import { ReactNode } from 'react';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { Card, Stack } from '@/components/ui/daisy';
import { FlipBtn } from '@/components/question/view/primitives/standard/FlashcardFlipBtn';
import { UseFlashcardSwipeReturn } from './useFlashcardSwipe';
import { FlashcardFlipCard } from './FlashcardFlipCard';
import { FlashcardSwipeResultLabel } from './FlashcardSwipeFeedback';

type FlashcardStackProps = {
  front?: ReactNode;
  back?: ReactNode;
  showBack?: boolean;
  flipPlaceholder?: string;
  onFlip?: () => void;
  swipe?: UseFlashcardSwipeReturn;
  draggable?: boolean;
};

export const flashcardPreviewClass = `
  w-full h-fit bg-transparent!
  [&_figure]:max-w-[200px]! [&_figure]:max-h-[200px]!
  [&_img]:object-contain
`;

const flashcardStackGridClass = `
  grid-cols-[20px_10px_260px_10px_20px]
  grid-rows-[52px_28px_240px_12px_8px]
`;

export const FlashcardStack = ({
  front,
  back,
  showBack = false,
  flipPlaceholder,
  onFlip,
  swipe,
  draggable = false,
}: FlashcardStackProps) => {
  const showSwipeFeedback = !!swipe && showBack;

  return (
    <div className="flex flex-col items-center gap-6">
      <div className="relative">
        <Stack
          align="bottom"
          className={'size-80 grid ' + flashcardStackGridClass}
        >
          <FlashcardFlipCard
            front={front}
            back={back}
            showBack={showBack}
            showSwipeFeedback={showSwipeFeedback}
            onFlip={onFlip}
            swipe={swipe}
            draggable={draggable}
          />
          <Card className="rounded-2xl bg-flashcard-stack-primary shadow-md opacity-100" />
          <Card className="rounded-2xl bg-flashcard-stack-secondary shadow-md opacity-100" />
        </Stack>

        <ConditionalRenderer condition={!showBack}>
          <div className="absolute top-0 z-20 flex w-80 justify-end">
            <FlipBtn onFlip={onFlip} flipPlaceholder={flipPlaceholder} />
          </div>
        </ConditionalRenderer>
      </div>

      <ConditionalRenderer condition={showSwipeFeedback}>
        <FlashcardSwipeResultLabel
          successOpacity={swipe?.successOpacity}
          errorOpacity={swipe?.errorOpacity}
        />
      </ConditionalRenderer>
    </div>
  );
};
